
import { defineComponent, ref, watch } from 'vue'
import { CommonDialog, AdminTableLayout, ReportTable } from '@/components/Common'
import {
  useDialogCommon,
  useReportTableShowColumn,
} from '@/hooks'
import { FileUploadAgain, GetDownloadList, GetPrivateFile } from '@/api-server/modules/defaultServer'

import { tableColumn } from './failTableColumn'
import { ElMessage, ElMessageBox } from 'element-plus'

export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    formData: {
      type: Array,
      default: () => ([]),
    },
  },

  components: {
    CommonDialog,
    AdminTableLayout,
    ReportTable,
  },

  emits: ['update:visible'],

  setup(props, context) {
    const { visibleRef } = useDialogCommon(props, context)
    const loading = ref(false)

    const { showTableColumn } = useReportTableShowColumn(tableColumn)

    const handleExport = async (row: any) => {
      ElMessage.success({ showClose: true, message: "导出成功" })
    }

    return {
      loading,
      showTableColumn,
      visibleRef,
      handleExport,
    }
  },
})
